
import commonUtil from 'packages/common-util/index.js';

const checkActionPermission = function(fc, ac, that) {
  const _this = this || that;

  if (_this && _this.isGrouporgProjectCenter) {
    return true;
  }
  if (!ac) {
    ac = fc;
    fc = _this.$route.meta.functionCode;
  }

  return commonUtil.checkActionPermission(fc, ac, _this);
};

/**
 * 针对Admin === '1'用户新增处理判断
 * @param {*} fc
 * @param {*} ac
 * @returns
 */
const checkActionAdminPermission = function(fc, ac, that) {
  const isAdmin = window.localStorage.admin;
  if (isAdmin === '1') return true;
  return checkActionPermission(fc, ac, that);
};

export default {
  checkActionPermission,
  checkActionAdminPermission
};
